import React from 'react';
import { useLocation, useParams } from 'react-router';
import cx from 'classnames';
import { SUBJECT_LIBRARY_TAB_SLUG } from '@yandex-int/k-common';
import { Text, useRouterPath, useStaticUrls } from 'platform-components';

import { LibraryBreadcrumbLink } from '../__link/breadcrumb__link';

interface Props {
    mix?: string;
}

export const LibraryBreadcrumbCalendarPlanShowcase = ({ mix }: Props) => {
    const staticUrls = useStaticUrls();
    const params = useParams<Record<string, string>>();
    const tabSlug = SUBJECT_LIBRARY_TAB_SLUG.TIMELINE;
    const { search } = useLocation();

    let path;

    if (params.subject === 'informatics') {
        path = params.classId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary;
    } else {
        path = params.classId ? staticUrls.labClassLibrarySubjectTab : staticUrls.labLibrarySubjectTab;
    }
    const generatedPath = useRouterPath(path, { tabSlug });
    const linkTo = `${generatedPath}${search}`;

    return (
        <div className={cx('library-breadcrumb', mix)}>
            <LibraryBreadcrumbLink to={linkTo}>
                <Text id="library.calendarPlanShowcase.returnToShowcase" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
            </LibraryBreadcrumbLink>
        </div>
    );
};
